import axios from '../utils/index';
import { Pat } from '@/typings/request';

const businessAdminInvoicesApi = {
    async getList(params: Pat) {
        return axios.get(`/business-admin-job/invoice/list`, { params });
    },
};

export default businessAdminInvoicesApi;
